// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2skbY","fullView":"styles_fullView__3_vMf"};